import Examples from './Examples'

export default Examples
